import { TextInput } from 'react-admin';

export const SearchByStatus = (
  <TextInput source="status" label="Search by status" alwaysOn />
)

export const SearchByUser = (
  <TextInput source="user_id" label="Search by user id" alwaysOn />
)
